export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-alabaster py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10 pb-12 border-b border-alabaster/10">
          <div>
            <h2 className="font-serif text-4xl sm:text-5xl leading-none">
              Brew <span className="italic text-taupe">&amp;</span> Co.
              <span className="block text-base text-alabaster/50 mt-3 font-sans font-light tracking-normal">
                Coffee catering, poured with care.
              </span>
            </h2>
            <div className="mt-6 flex items-center gap-3">
              <span className="font-mono text-[10px] uppercase tracking-widest text-alabaster/40" data-testid="footer-powered-by-text">Powered by <span className="text-alabaster/60">Coffee Pause</span></span>
            </div>
          </div>
          <div className="font-mono text-[11px] uppercase tracking-widest text-alabaster/60 flex flex-col gap-2">
            <a href="mailto:menelaosstokkos8@gmail.com" data-testid="footer-email-link" className="hover:text-alabaster transition-colors">menelaosstokkos8@gmail.com</a>
            <a href="tel:99341431" data-testid="footer-phone-link" className="hover:text-alabaster transition-colors">99 341 431</a>
            <span>Mobile coffee bar — at your venue</span>
          </div>
        </div>
        <div className="pt-8 flex flex-col sm:flex-row justify-between gap-3 font-mono text-[10px] uppercase tracking-widest text-alabaster/40">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} Brew &amp; Co. — powered by Coffee Pause</span>
          <span>Slow coffee, poured warm</span>
        </div>
      </div>
    </footer>
  );
}
